import React, { useEffect, useState } from "react";
import brandConfig from "../config/brand";
import { getCurrentSplitAssignment, subscribeSplitAssignment } from "../utils/splitTest";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  // Split test: an assigned visitor sees the arm's tracked number instead of
  // the brand default. It is not a CallRail swap target, so a later swap
  // pass leaves it alone.
  const [splitAssignment, setSplitAssignment] = useState(() => getCurrentSplitAssignment());
  useEffect(() => subscribeSplitAssignment(setSplitAssignment), []);
  // A direct-arm visitor who chose "Business" is out of the test's scope and
  // continues the normal commercial funnel with the brand number.
  const splitPhone = splitAssignment?.phone_display && splitAssignment?.phone_e164
    && splitAssignment.commercial !== true
    ? { display: splitAssignment.phone_display, e164: splitAssignment.phone_e164 }
    : null;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // --- ADDED THIS useEffect BLOCK FOR CALLRAIL ---
  useEffect(() => {
    if (window.CallRail) {
      window.CallRail.swap();
    }
  }, []);
  // --- END OF THE NEW BLOCK ---

  const handlePhoneClick = () => {
    window.parent.postMessage(
      {
        type: "gtag_event",
        numberclick: (splitPhone ? splitPhone.e164 : brandConfig.phone || '').replace(/\D/g, ''),
        brand: brandConfig.key,
      },
      "*"
    );
  };
  // Promo banner: visible on every form branch when the visitor arrives
  // from a Meta retargeting URL (utm_campaign starts with "retargeting")
  // or directly via ?promo=100OFF1.
  const hasPromo = (typeof window !== 'undefined' && window.localStorage)
    ? window.localStorage.getItem('promo') === '100OFF1'
    : false;

  return (
    <>
      {hasPromo && (
        <div className="promo-banner" role="status">
          <span className="promo-banner-tag">$100 off your first month</span>
          <span className="promo-banner-text">applied to your quote.</span>
        </div>
      )}
      <header className={`header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-content">
          <div className="logo">
            {/* <Link> */}
              <img
                src={brandConfig.logo}
                className="appLogo"
                alt={`${brandConfig.name} logo`}
                width={150}
              />
            {/* </Link> */}
          </div>
          <div className="header-menu hide-face-img">
            <div
              className={`${
                scrolled ? "avatar-compact-mod" : "header-humanoid"
              }`}
              aria-label="maya-avatar"
            >
              <span className="avatar med" />
            </div>
          </div>
          <div className="phone-number">
            {splitPhone ? (
              <a key="split-phone" href={`tel:${splitPhone.e164}`} data-split-phone="header" style={{
                whiteSpace: 'nowrap'
              }} onClick={handlePhoneClick}>{splitPhone.display}</a>
            ) : (
              <a key="brand-phone" href={`tel:${(brandConfig.phone || '').replace(/\D/g, '')}`} style={{
                whiteSpace: 'nowrap'
              }} onClick={handlePhoneClick}>{brandConfig.phone}</a>
            )}
          </div>
        </div>
        <div className="form-progress-bar">
          <div className="form-progress-slider"></div>
        </div>
      </header>
      {/* <div className="google-reviews">
        <img src="/images/google_data.png"></img>
      </div> */}
    </>
  );
};

export default Header;
